export function required(errorMsg) {
    return function (value) {
        if (!value) {
            return errorMsg || 'required';
        }
    }
}

export function match(re, errorMsg) {
    return function (value) {
        if (!re.test(value)) {
            return errorMsg || 'invalid';
        }
    }
}

export function notMatch(re, errorMsg) {
    return function (value) {
        if (re.test(value)) {
            return errorMsg || 'invalid';
        }
    }
}

export function number(errorMsg) {
    return function (value) {
        if (isNaN(value)) {
            return errorMsg || 'only numbers';
        }
    }
}

export function min(limit, errorMsg) {
    return function (value) {
        if (Number(value) < limit) {
            return errorMsg || `min value is ${limit}`;
        }
    }
}

export function max(limit, errorMsg) {
    return function (value) {
        if (Number(value) > limit) {
            return errorMsg || `max value is ${limit}`;
        }
    }
}

export function min_length(limit, errorMsg) {
    return function (value) {
        if (value.length < limit) {
            return errorMsg || `min length is ${limit}`;
        }
    }
}

export function max_length(limit, errorMsg) {
    return function (value) {
        if (value.length > limit) {
            return errorMsg || `max length is ${limit}`;
        }
    }
}

export function startsWith(prefix, errorMsg) {
    return function (value) {
        if (!value.startsWith(prefix)) {
            return errorMsg || `must be ${prefix} prefix`
        }
    }
}

export function integer(errorMsg) {
    return function (value) {
        if (!Number.isInteger(Number(value))) {
            return errorMsg || 'must be integer';
        }
    }
}

export function validateField(validator, fieldName, fieldValue, ...options) {
    for (const func of validator[fieldName]) {
        let errorMsg = func(fieldValue, ...options);
        if (!!errorMsg) {
            return errorMsg;
        }
    }
    return '';
}

export const RUSSIA_CODE = '643'

function matchPassportNumber() {
    return function (value, countryCode) {
        if (countryCode === RUSSIA_CODE) {
            if (!/^\d{6}$/.test(value)) {
                return 'must be 6 digits'
            }
        } else {
            if (value.length > 8) {
                return 'max 8 chars'
            }
        }
    }
}

export const phoneReRU = /^\+7\s\d{3}\s\d{3}-\d{2}-\d{2}$/;
const currentYear = new Date().getFullYear();

export const validatorRU = {
    referenceNumber: [required(), match(/^[a-zA-Z0-9-]+$/, 'allowed only: english chars, digits, hyphen'), min_length(5)],
    phone: [required(), match(phoneReRU, 'must match +7 905 123-45-67')],
    email: [required(), match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)],
    name: [required(), match(/^[a-zA-Z-]+$/, 'allowed only: english chars')],
    middlename: [required(), match(/^[a-zA-Z-]+$/, 'allowed only: english chars')],
    surname: [required(), match(/^[a-zA-Z-]+$/, 'allowed only: english chars')],
    individualTaxpayerNumber: [required(), match(/^\d{12}$/, 'must be 12 digits')],

    passportSeries: [required(), match(/^\d{4}$/, 'must be 4 digits')],
    passportNumber: [required(), matchPassportNumber()],
    passportYear: [required(), match(/^\d{4}$/, 'must be 4 digits'), min(1900, `allowed from 1900 to ${currentYear}`), max(currentYear, `allowed from 1900 to ${currentYear}`)],
    passportMonth: [required(), match(/^\d{1,2}$/, 'must be 1 or 2 digits'), min(1, 'allowed from 1 to 12'), max(12, 'allowed from 1 to 12')],
    passportDay: [required(), match(/^\d{1,2}$/, 'must be 1 or 2 digits'), min(1, 'allowed from 1 to 31'), max(31, 'allowed from 1 to 31')],
    passportIssuedBy: [required(), max_length(150)],

    zip: [required(), match(/^[0-9]{6}$/, 'must be 6 digits')],
    region: [required(), max_length(60)],
    city: [required(), max_length(60)],
    street: [required(), max_length(100)],
    house: [required(), max_length(10)],
    corpus: [max_length(10)],
    apartment: [max_length(10)],

    link: [required(), startsWith('http'), min_length(12)],
    description: [required(), match(/^[\x00-\x7F]+$/, 'allowed only: english chars'), notMatch(/^http.*$/, 'urls not allowed'), min_length(2)],
    price: [required(), number(), min(0.01)],
    quantity: [required(), number(), min(1)],

    bxbRegion: [required()],
    bxbCity: [required()],
    bxbStreet: [required()],
};
